import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import Layout from "./components/Layout";
import AdminPage from "./components/Admin/AdminPage";
import HomePage from "./components/HomePage";
import PersistLogin from "./components/PersistLogin";
import RequireAuth from "./components/RequireAuth";
import ViewEventsTable from "./components/common/Tables/ViewEventsTable";
import Devices from "./components/Devices/Devices";
import RegisterDevices from "./components/common/Devices/RegisterDevices";
import Profile from "./components/Profile/Profile";
import "./App.css";
import ViewEventsModal from "./components/Events/ViewEventsModal";
import UserManagement from "./components/UserManagement/UserManagement";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import SetupPage from "./components/Setup/SetupPage";
import SSOCallback from "./components/SSOCallback";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="setup" element={<SetupPage />} />
        <Route path="/sso/callback/:provider" element={<SSOCallback />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />

        <Route element={<PersistLogin />}>
          <Route path="/" element={<LoginPage />} />

          <Route element={<RequireAuth />}>
            <Route element={<AdminPage />}>
              <Route path="home" element={<HomePage />} />
              <Route path="events" element={<ViewEventsModal />} />
              <Route path="profile" element={<Profile />} />
              <Route path="devices" element={<Devices />} />
              <Route path="settings" element={<UserManagement />} />

              <Route
                path="devices/register-device"
                element={<RegisterDevices />}
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
